module.exports = __webpack_public_path__ + "img/button_icon_reseller.427af5e.svg";